import { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { DateInput } from "../formComponents/DateInput";
import { LogTypeSelect } from "../formComponents/LogTypeSelect";
import { TimeDevice } from "../formComponents/TimeDevice";
import { ClassificationIdSelectDummy } from "../formComponents/ClassificationIdSelectDummy";
import { ClassificationIdSelect } from "../formComponents/ClassificationIdSelect";


export function SelectLogsForm({ isOpen,
  onClose,
  dateFromLogs,
  setDateFromLogs,
  dateToLogs,
  setDateToLogs,
  employeePersonalInformationId,
  setEmployeePersonalInformationId,
  employeePersonalInformationFullName,
  setEmployeePersonalInformationFullName,
  deviceLogs,
  setDeviceLogs,
  setShowEmployeeForm,
  classificationFilterForAdminHRHead,
  setClassificationFilterForAdminHRHead,
  classificationFilterForHRAsst2,
  setClassificationFilterForHRAsst2,
  classificationFilterForHRAsst3,
  setClassificationFilterForHRAsst3,
  handleSelectDataLogs,
  handleSelectDataLogs_Mobile,
  handleSelectDataLogs_main,
  userAccessData,
  user
}) {
  const [errorState, setErrorState] = useState(false);
  const [logType, setLogType] = useState("Sentry Biometrics");

  const submit = (e) => {
    if (!dateFromLogs
      || !dateToLogs
    ) {
      setErrorState(true);
      return;
    }
    handleClose();
    // if(logType === "Sentry Biometrics"){
    //     handleSelectDataLogs(e);
    // } else {
    //     handleSelectDataLogs_Mobile(e);
    // }
    handleSelectDataLogs_main(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setDateFromLogs("");
    setDateToLogs("");
    setEmployeePersonalInformationId("");
    setEmployeePersonalInformationFullName("");
    setDeviceLogs("");
    setLogType("DTR Biometrics");
    setErrorState(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Data Logs</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column" style={{ display: "none" }}>
                <div className="info-item-label">Log Type</div>
                <div className="info-item-input">
                  <LogTypeSelect logType={logType} setLogType={setLogType} />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Date From</div>
                <div className="info-item-input">
                  <DateInput date={dateFromLogs} setDate={setDateFromLogs} />
                </div>
                <span style={{
                  visibility: !dateFromLogs && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Date To</div>
                <div className="info-item-input">
                  <DateInput date={dateToLogs} setDate={setDateToLogs} />
                </div>
                <span style={{
                  visibility: !dateToLogs && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              {userAccessData.length <= 0 &&
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Classification Type</div>
                  <div className="info-item-input">
                    <ClassificationIdSelectDummy />
                    <span style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px"
                    }}>Please fill up this field
                    </span>
                  </div>
                </div>
              }
              <div className="popUp-item info-item column">
                <div className="info-item-label">Classification Type</div>
                <div className="info-item-input">
                  <ClassificationIdSelect classificationId={classificationFilterForAdminHRHead} setClassificationId={setClassificationFilterForAdminHRHead} user={user} />
                  <span style={{
                    visibility: "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>
              {logType === "Sentry Biometrics" &&
                <div className="popUp-item info-item column" style={{ display: "none" }}>
                  <div className="info-item-label">Device Name</div>
                  <div className="info-item-input">
                    <TimeDevice device={deviceLogs} setDevice={setDeviceLogs} />
                  </div>
                  <span style={{
                    visibility: "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              }
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "40px 40px 20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
                style={{ marginRight: "5px" }}>
                SELECT
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}